var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { class: _vm.getNavClass(), attrs: { id: "vertical-nav" } },
    [
      _vm.deviceType == "mobile"
        ? [
            _c(
              "li",
              {
                staticClass: "nav-btn",
                class: { active: _vm.showMenu },
                on: { click: _vm.toggleMenu }
              },
              [
                _vm.page !== "/permits"
                  ? _c("img", {
                      staticClass: "hover-opacity",
                      staticStyle: { width: "24px" },
                      attrs: {
                        src: require("../assets/css/svg/scoutred-icon.svg")
                      }
                    })
                  : _c("i", { staticClass: "material-icons md-24" }, [
                      _vm._v("business_center")
                    ]),
                _vm._v(" "),
                _vm.showMenu
                  ? _c("ul", { staticClass: "expand-nav" }, [
                      _vm.page !== "/permits"
                        ? _c(
                            "li",
                            {
                              class: { active: _vm.page === "/permits" },
                              on: { click: _vm.permits }
                            },
                            [
                              _vm._m(0),
                              _vm._v(" "),
                              _c("div", { staticClass: "nav-label" }, [
                                _vm._v("Permits")
                              ])
                            ]
                          )
                        : _c(
                            "li",
                            {
                              class: { active: _vm.page === "/home" },
                              on: { click: _vm.home }
                            },
                            [
                              _vm._m(1),
                              _vm._v(" "),
                              _c("div", { staticClass: "nav-label" }, [
                                _vm._v("Parcels")
                              ])
                            ]
                          ),
                      _vm._v(" "),
                      _vm.planCurrentIsDayPass
                        ? _c(
                            "li",
                            {
                              class: { active: _vm.page === "/plan" },
                              on: { click: _vm.plan }
                            },
                            [
                              _c("div", { staticClass: "nav-left-icon" }, [
                                _c(
                                  "div",
                                  { staticClass: "spinner spinner-sm" },
                                  [
                                    _c("div", {
                                      staticClass: "half right",
                                      style: _vm.spinnerRight
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "half cover",
                                      style: _vm.spinnerCover
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "half left",
                                      style: _vm.spinnerLeft
                                    }),
                                    _vm._v(" "),
                                    _c("div", {
                                      staticClass: "stop",
                                      style: _vm.spinnerStop
                                    })
                                  ]
                                )
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "nav-label" }, [
                                _vm._v("Day pass")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.planCurrentIsStudio
                        ? _c(
                            "li",
                            {
                              class: { active: _vm.page === "/plan" },
                              on: { click: _vm.plan }
                            },
                            [
                              _vm._m(2),
                              _vm._v(" "),
                              _c("div", { staticClass: "nav-label" }, [
                                _vm._v("Studio subscription")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: { active: _vm.page === "/collections" },
                          on: { click: _vm.collections }
                        },
                        [
                          _vm._m(3),
                          _vm._v(" "),
                          _c("div", { staticClass: "nav-label" }, [
                            _vm._v("Parcel collections")
                          ])
                        ]
                      ),
                      _vm._v(" "),
                      !_vm.token
                        ? _c(
                            "li",
                            {
                              class: { active: _vm.page === "/auth" },
                              attrs: { title: "login or sign up" },
                              on: { click: _vm.agent }
                            },
                            [
                              _vm._m(4),
                              _vm._v(" "),
                              _c("div", { staticClass: "nav-label" }, [
                                _vm._v("Login or sign up")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.token
                        ? _c(
                            "li",
                            {
                              class: { active: _vm.page === "/auth" },
                              attrs: { title: "my account" },
                              on: { click: _vm.agent }
                            },
                            [
                              _vm._m(5),
                              _vm._v(" "),
                              _c("div", { staticClass: "nav-label" }, [
                                _vm._v("User account")
                              ])
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "li",
                        {
                          class: { active: _vm.page === "/auth" },
                          attrs: { title: "message Scoutred" },
                          on: { click: _vm.message }
                        },
                        [
                          _vm._m(6),
                          _vm._v(" "),
                          _c("div", { staticClass: "nav-label" }, [
                            _vm._v("Message Scoutred")
                          ])
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            )
          ]
        : [
            _c(
              "li",
              {
                staticClass: "nav-item px-2 py-2 red",
                class: { active: _vm.page === "/" },
                on: { click: _vm.home }
              },
              [
                _c("img", {
                  staticClass: "hover-opacity",
                  staticStyle: { width: "2rem" },
                  attrs: { src: require("../assets/css/svg/scoutred-icon.svg") }
                }),
                _vm._v(" "),
                _vm._m(7)
              ]
            ),
            _vm._v(" "),
            _c(
              "li",
              {
                staticClass: "nav-item px-2 py-2",
                class: { active: _vm.page === "/permits" },
                on: { click: _vm.permits }
              },
              [
                _c("i", { staticClass: "material-icons md-36" }, [
                  _vm._v("business_center")
                ]),
                _vm._v(" "),
                _vm._m(8)
              ]
            ),
            _vm._v(" "),
            _c("li", { staticClass: "flex-2" }),
            _vm._v(" "),
            _vm.planCurrentIsDayPass
              ? _c(
                  "li",
                  {
                    staticClass: "nav-item px-2 py-2",
                    class: { active: _vm.page === "/plan" },
                    on: { click: _vm.plan }
                  },
                  [
                    _c("div", { staticClass: "spinner" }, [
                      _c("div", {
                        staticClass: "half right",
                        style: _vm.spinnerRight
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "half cover",
                        style: _vm.spinnerCover
                      }),
                      _vm._v(" "),
                      _c("div", {
                        staticClass: "half left",
                        style: _vm.spinnerLeft
                      }),
                      _vm._v(" "),
                      _c("div", { staticClass: "stop", style: _vm.spinnerStop })
                    ]),
                    _vm._v(" "),
                    _vm._m(9)
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.planCurrentIsStudio
              ? _c(
                  "li",
                  {
                    staticClass: "nav-item px-2 py-2",
                    class: { active: _vm.page === "/plan" },
                    on: { click: _vm.plan }
                  },
                  [
                    _c("i", { staticClass: "material-icons md-36" }, [
                      _vm._v("verified_user")
                    ]),
                    _vm._v(" "),
                    _vm._m(10)
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.token
              ? _c(
                  "li",
                  {
                    staticClass: "nav-item px-2 py-2",
                    class: { active: _vm.page === "/collections" },
                    on: { click: _vm.collections }
                  },
                  [
                    _c("i", { staticClass: "material-icons md-36" }, [
                      _vm._v("book")
                    ]),
                    _vm._v(" "),
                    _vm._m(11)
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.token
              ? _c(
                  "li",
                  {
                    staticClass: "nav-item px-2 py-2",
                    class: { active: _vm.page === "/auth" },
                    attrs: { title: "login or sign up" },
                    on: { click: _vm.agent }
                  },
                  [
                    _c("i", { staticClass: "material-icons md-36" }, [
                      _vm._v("person_outline")
                    ]),
                    _vm._v(" "),
                    _vm._m(12)
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.token
              ? _c(
                  "li",
                  {
                    staticClass: "nav-item px-2 py-2",
                    class: { active: _vm.page === "/auth" },
                    attrs: { title: "my account" },
                    on: { click: _vm.agent }
                  },
                  [
                    _c("i", { staticClass: "material-icons md-36" }, [
                      _vm._v("person")
                    ]),
                    _vm._v(" "),
                    _vm._m(13)
                  ]
                )
              : _vm._e()
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-left-icon" }, [
      _c("i", { staticClass: "material-icons md-24" }, [
        _vm._v("business_center")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-left-icon" }, [
      _c("img", {
        staticClass: "hover-opacity",
        staticStyle: { width: "24px" },
        attrs: { src: require("../assets/css/svg/scoutred-icon.svg") }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-left-icon" }, [
      _c("i", { staticClass: "material-icons md-24" }, [
        _vm._v("verified_user")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-left-icon" }, [
      _c("i", { staticClass: "material-icons md-24" }, [
        _vm._v("folder_special")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-left-icon" }, [
      _c("i", { staticClass: "material-icons md-24" }, [
        _vm._v("person_outline")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-left-icon" }, [
      _c("i", { staticClass: "material-icons md-24" }, [_vm._v("person")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "nav-left-icon" }, [
      _c("i", { staticClass: "material-icons md-24" }, [_vm._v("chat")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint" }, [
      _c("span", [_vm._v("Parcels and zoning")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint" }, [_c("span", [_vm._v("Permits")])])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint" }, [
      _c("span", [_vm._v("Day plan")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint" }, [
      _c("span", [_vm._v("Studio subscription")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint" }, [
      _c("span", [_vm._v("Parcel collections")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint" }, [
      _c("span", [_vm._v("Login or sign up")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "hint" }, [
      _c("span", [_vm._v("User account")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4925b7ed", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4925b7ed","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/left-nav.vue
// module id = null
// module chunks = 